import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect } from 'react';

// @ts-expect-error - TS7016 - Could not find a declaration file for module 'jwt-decode'. '/buildeng/bamboo-agent-home/xml-data/build-dir/JF-TSMIG123-APPLY/node_modules/jwt-decode/lib/index.js' implicitly has an 'any' type.
import jwtDecode from 'jwt-decode';
import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import { fireUIAnalytics } from '@atlassian/analytics-bridge';
import { transformReadAttachmentsToken } from '@atlassian/jsm-attachment';
import { Action, ActionSubject } from '@atlassian/proforma-utils/analytics';
import { useMediaContext } from '../../context';
export var useEmitAttachmentMetrics = function useEmitAttachmentMetrics(formStore, view) {
  var _useMediaContext = useMediaContext(),
    mediaApiReadToken = _useMediaContext.mediaApiReadToken,
    mediaUploadAndViewContexts = _useMediaContext.mediaUploadAndViewContexts,
    projectId = _useMediaContext.projectId,
    portalId = _useMediaContext.portalId,
    issueKey = _useMediaContext.issueKey;
  var _useAnalyticsEvents = useAnalyticsEvents(),
    createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
  useEffect(function () {
    if (view && formStore.numberOfAttachment > 0) {
      try {
        var _mediaUploadAndViewCo;
        var viewContextToken = mediaUploadAndViewContexts ? (_mediaUploadAndViewCo = mediaUploadAndViewContexts.viewContext) === null || _mediaUploadAndViewCo === void 0 ? void 0 : _mediaUploadAndViewCo.token : mediaApiReadToken ? transformReadAttachmentsToken(mediaApiReadToken).token : null;
        var viewableIds = new Set();
        if (viewContextToken) {
          // when there are no attachments, the token will be undefined and so do not decode
          var _ref = jwtDecode(viewContextToken),
            access = _ref.access;
          var viewableFiles = Object.entries(access).filter(function (_ref2) {
            var _ref3 = _slicedToArray(_ref2, 2),
              _ = _ref3[0],
              value = _ref3[1];
            return value.includes('read');
          });
          viewableIds = new Set(viewableFiles.flatMap(function (_ref4) {
            var _ref5 = _slicedToArray(_ref4, 2),
              key = _ref5[0],
              _ = _ref5[1];
            return key.split(':')[3];
          }));
        }
        var brokenFiles = formStore.questions.filter(function (questionStore) {
          return questionStore.formQuestion.type === 'at';
        }).flatMap(function (questionStore) {
          var attachments = questionStore.currentAnswer;
          return attachments.filter(function (attachment) {
            return !viewableIds.has(attachment.id);
          });
        });
        var attachmentIdCreationDtStr = function attachmentIdCreationDtStr(attachments) {
          return attachments.map(function (attachment) {
            return "".concat(attachment.id, ": ").concat(attachment.creationDate);
          }).join(', ');
        };
        if (brokenFiles.length > 0) {
          fireUIAnalytics(createAnalyticsEvent({
            actionSubject: ActionSubject.ATTACHMENT_VIEWER_CARD,
            action: Action.FAILED
          }), "".concat(ActionSubject.ATTACHMENT_VIEWER_CARD, " ").concat(Action.FAILED), projectId ? {
            projectId: projectId,
            issueKey: issueKey,
            attachmentCreationDate: attachmentIdCreationDtStr(brokenFiles)
          } : {
            portalId: portalId,
            issueKey: issueKey,
            attachmentCreationDate: attachmentIdCreationDtStr(brokenFiles)
          });
        }
      } catch (error) {
        fireUIAnalytics(createAnalyticsEvent({
          actionSubject: ActionSubject.ATTACHMENT_VIEWER_CARD,
          action: Action.FAILED
        }), "".concat(ActionSubject.ATTACHMENT_VIEWER_CARD, " ").concat(Action.FAILED), projectId ? {
          projectId: projectId,
          issueKey: issueKey,
          error: JSON.stringify(error)
        } : {
          portalId: portalId,
          issueKey: issueKey,
          error: JSON.stringify(error)
        });
      }
    }
    // disabling exhaustive-deps as the metric is to track failed to load attachments which only occurs on first render
    // and we do not want duplicate events on re-renders
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [createAnalyticsEvent, issueKey, portalId, projectId]);
};